import { render } from "./AppSwitch.vue?vue&type=template&id=762b661f&scoped=true&ts=true"
import script from "./AppSwitch.vue?vue&type=script&lang=ts"
export * from "./AppSwitch.vue?vue&type=script&lang=ts"

import "./AppSwitch.vue?vue&type=style&index=0&id=762b661f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-762b661f"]])

export default __exports__